import React from "react";
import "./blog.css";
import { Article } from "../../components";
import { blog01, blog02, blog03, blog04, blog05 } from "./import";

const Blog = () => {
  return (
    <div className="webpage__blog section__padding" id="blog">
      <div className="webpage__blog-heading">
        <h1 className="gradient__text">
          a lot is happening ,we have our blogging section
        </h1>
      </div>
      <div className="webpage__blog-container">
        <div className="webpage__blog-container_groupA">
          <Article imgUrl={blog05} date="22-06-2022"  title="blog 05 this is the blog s for the day and wer will back to you tomorrow,please do wait"/>
        </div>
        <div className="webpage__blog-container_groupB">
          <Article imgUrl={blog01} date="22-06-2022" title="this is the blog s for the day and wer will back to you tomorrow,please do wait"/> 
          <Article imgUrl={blog02} date="22-06-2022" title="this is the blog s for the day and wer will back to you tomorrow,please do wait"/>
          <Article imgUrl={blog03} date="22-06-2022" title="this is the blog s for the day and wer will back to you tomorrow,please do wait"/>
          <Article imgUrl={blog04}  date="22-06-2022"  title="this is the blog s for the day and wer will back to you tomorrow,please do wait"/>
        </div>
      </div>
    </div>
  );
};

export default Blog;